/**
 * ai.viewstate - capture current view state via agent layer or store context
 * args: { rootState }
 */
module.exports = async function viewstate(helpers = {}, args = {}) {
  void helpers
  const { rootState } = args

  // Prefer a preserved view_scope in terminal.context
  const terminalContext = rootState && rootState.terminal && Array.isArray(rootState.terminal.context) ? rootState.terminal.context : []
  const viewScopeItem = terminalContext.find(i => i && i.type === 'view_scope')
  if (viewScopeItem) return viewScopeItem.value

  // Fall back to window.agentLayer if available
  try {
    if (typeof window !== 'undefined' && window.agentLayer && window.agentLayer.discoverViewScope) {
      return window.agentLayer.discoverViewScope()
    }
  } catch (e) {
    // ignore
  }

  return null
}
